import script from "./DefaultFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultFrame.vue?vue&type=script&setup=true&lang=js"

import "./DefaultFrame.vue?vue&type=style&index=0&id=7714e14d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7714e14d"]])

export default __exports__